import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.object({
    lookupAccount: Yup.string().required('Required').nullable(),
    lookupName: Yup.string().required('Required').nullable(),
  });
